import { withHTMLComponent } from '@updater/ui-custom-element';

var styles = ":host {\n  display: inline-block;\n  vertical-align: top;\n  height: 1em;\n  width: 1em;\n  fill: currentcolor;\n}\n\nsvg {\n  height: 1em;\n  align-self: center;\n}\n\ndiv {\n  height: 1em;\n  width: 1em;\n  /* IE11 doesn't like this element being flex and needs it to be inline-flex */\n  display: inline-flex;\n  justify-content: center;\n}\n";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ERROR_SVG = '\n<svg xmlns="http://www.w3.org/2000/svg" class="error" viewBox="0 0 512 512"><path d="M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"/></svg>\n';

var cache = {};

var FAIcon = function (_withHTMLComponent) {
  _inherits(FAIcon, _withHTMLComponent);

  _createClass(FAIcon, [{
    key: 'handleResponse',
    value: function handleResponse(resolve, reject) {
      return function (_ref) {
        var _ref$target = _ref.target,
            status = _ref$target.status,
            responseText = _ref$target.responseText;

        status === 200 && responseText.length > 0 && responseText.substr(0, 4) === '<svg' ? resolve(responseText) : reject();
      };
    }
  }], [{
    key: 'observedAttributes',
    get: function get() {
      return ['name', 'type'];
    }
  }, {
    key: 'reflectedAttributes',
    get: function get() {
      return [{ name: 'name' }, { name: 'type' }];
    }
  }]);

  function FAIcon() {
    _classCallCheck(this, FAIcon);

    var _this = _possibleConstructorReturn(this, (FAIcon.__proto__ || Object.getPrototypeOf(FAIcon)).call(this));

    _this._svgMount = _this.shadowRoot.querySelector('div');
    return _this;
  }

  _createClass(FAIcon, [{
    key: 'updated',
    value: function updated(_ref2) {
      var _this2 = this;

      var _ref2$type = _ref2.type,
          type = _ref2$type === undefined ? 'solid' : _ref2$type,
          name = _ref2.name;

      var cacheKey = type + '_' + name;

      if (!cache[cacheKey]) {
        cache[cacheKey] = new Promise(function (resolve, reject) {
          var req = new XMLHttpRequest();
          name = name.toLowerCase();
          type = type.toLowerCase();
          req.onload = _this2.handleResponse(resolve, reject);
          req.open('GET', '//d30c45h9cuv4p4.cloudfront.net/font-awesome/' + type + '/' + name + '.svg');
          req.send();
        });
      }

      cache[cacheKey].then(function (svg) {
        _this2._svgMount.innerHTML = svg;
      }, function () {
        _this2._svgMount.innerHTML = ERROR_SVG;
      });
    }
  }]);

  return FAIcon;
}(withHTMLComponent(styles, '<div></div>')());

customElements.define('upd-fa-icon', FAIcon);
